// extracted by mini-css-extract-plugin
module.exports = {"infoRow":"eventDetails_infoRow__4Tos7","withIcon":"eventDetails_withIcon__YFa_L","text":"eventDetails_text__etkzo"};